<template>
  <div class="list">
    <div class="item2">
      <ul>
        <li class="items" style="padding: 5px 0">
          <div v-for="(item, index) in header" :key="index">
            {{ item.display_name }}
          </div>
        </li>
      </ul>
      <div class="listItems">
        <ul id="con1" ref="con1">
          <li v-for="(item, index) in list" :key="index" class="items">
            <div v-for="(item2, index2) in item" :key="index2">{{ item2 }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AreWarning",
  data() {
    return {
      header: [],
      list: [],
      height: 0,
    };
  },
  created() {
    this.$axios.get(`${this.$url}/admin/bigpin3`).then((res) => {
      let datas = JSON.parse(res.data.split("<\/script>")[1]).data;
      this.header = datas.cols;
      this.list = datas.rows;
    });
    setInterval(() => {
      this.scroll();
    }, 2000);
  },
  methods: {
    scroll() {
      setTimeout(() => {
        if (this.height >= document.getElementById("con1").offsetHeight) {
          this.$axios.get(`${this.$url}/admin/bigpin3`).then((res) => {
            let datas = JSON.parse(res.data.split("<\/script>")[1]).data;
            this.header = datas.cols;
            this.list = datas.rows;
          });
          this.height = 0;
        }
        document.getElementById("con1").style.transform = `translate(0 , ${-this
          .height}px)`;
        this.height += 50;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.list {
  /* width: 100%; */
  color: white;
  height: 100%;
}
.item2 {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.items {
  display: flex;
}
.items > div {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
div {
  text-align: center;
}

#con1 {
  transition: all 1s;
}

#con1 li {
  list-style: none;
  line-height: 30px;
  height: 30px;
}
.listItems {
  height: 100%;
  overflow: hidden;
}
.items {
  background-color: rgba(255, 255, 255, 0.3);
  margin-bottom: 10px;
}
.title {
  position: absolute;
  left: 2px;
  top: 2px;
}
</style>